<mat-card>
  <mat-card-content>
    <div class="subscription-details" *ngIf="!isLoading">
      <div class="subscription-detail-item" *ngIf="getSubscriptionPaidUntilDate()">
        <div class="detail-label">
          <mat-icon class="detail-icon">calendar_today</mat-icon>
          {{ 'settings.billing.subscriptionPaidUntil' | translate }}
        </div>
        <div class="detail-value">
          {{ dateFormatService.formatDate(getSubscriptionPaidUntilDate()) }}
        </div>
      </div>

      <div class="subscription-detail-item" *ngIf="getEstimatedMonthlyCost() !== null">
        <div class="detail-label">
          <mat-icon class="detail-icon">attach_money</mat-icon>
          {{ 'settings.billing.estimatedMonthlyCost' | translate }}
        </div>
        <div class="detail-value">
          {{ getEstimatedMonthlyCost() }} {{ form?.get('currency')?.value || billingSettings?.currency || 'USD' }}
        </div>
        <div class="detail-hint">
          {{ 'settings.billing.estimatedMonthlyCostHint' | translate }}
        </div>
      </div>

      <div class="subscription-detail-item" *ngIf="getEstimatedYearlyCost() !== null">
        <div class="detail-label">
          <mat-icon class="detail-icon">attach_money</mat-icon>
          {{ 'settings.billing.estimatedYearlyCost' | translate }}
        </div>
        <div class="detail-value">
          {{ getEstimatedYearlyCost() }} {{ form?.get('currency')?.value || billingSettings?.currency || 'USD' }}
        </div>
        <div class="detail-hint">
          {{ 'settings.billing.estimatedYearlyCostHint' | translate }}
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
